const formatLanguageCountryName = (locale, iso) =>
  locale[2] === "-" ? locale : `${locale}-${iso}`;
const toLanguageCountryName = (countryModel, separator) => {
  const languageTag = formatLanguageCountryName(
    countryModel.locale,
    countryModel.iso
  );

  if (separator) {
    return languageTag.replace("-", separator);
  }

  return languageTag;
};

module.exports = {
  formatLanguageCountryName,
  toLanguageCountryName,
};
